import { useEffect, useState } from 'react';

function Visible({ visible, children }: { visible: boolean; children: JSX.Element }) {
  const [visibled, setVisibled] = useState(visible);

  useEffect(() => {
    if (visible) {
      setVisibled(true);
    }
  }, [visible]);

  if (visibled) {
    return <div style={visible ? undefined : { display: 'none' }}>{children}</div>;
  }

  return <></>;
}

export default Visible;
